export default [
  {
    path: '/analytics/report',
    name: 'analytics-report',
    component: () => import('@/views/analytics/AnalyticsReport.vue'),
    meta: {
      resource: 'MailLog',
      action: 'read',
    },
  },
  {
    path: '/analytics/search-journey',
    name: 'analytics-search-journey',
    component: () => import('@/views/analytics/SearchJourney.vue'),
    meta: {
      resource: 'MailLog',
      action: 'read',
    },
  },
  {
    path: '/analytics/user-path',
    name: 'analytics-user-path',
    component: () => import('@/views/analytics/UserPath.vue'),
    meta: {
      resource: 'MailLog',
      action: 'read',
    },
  },
  {
    path: '/analytics/property-journey',
    name: 'analytics-property-journey',
    component: () => import('@/views/analytics/PropertyJourney.vue'),
    meta: {
      resource: 'MailLog',
      action: 'read',
    },
  },
]
